import { render, staticRenderFns } from "./user-diamond1.vue?vue&type=template&id=f566ac2c&scoped=true&"
import script from "./user-diamond1.vue?vue&type=script&lang=js&"
export * from "./user-diamond1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f566ac2c",
  null
  
)

export default component.exports